module.exports = __webpack_public_path__ + "static/media/qr-bg.2653a0ae.png";